import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    activeMandateTitle: 'Active Direct Debits',
    addMandateButton: 'Authorize a mandate',
    authorizedMandate: 'Authorized Direct Debit',
    suspendedMandate: 'Suspended Direct Debit',
    suspendedMandateTitle: 'Suspended Direct Debits',
    title: 'Direct Debits',
  },
  fr: {
    activeMandateTitle: 'Prélèvements actifs',
    addMandateButton: 'Ajouter un mandat',
    authorizedMandate: 'Prélèvement autorisé',
    suspendedMandate: 'Prélèvement suspendu',
    suspendedMandateTitle: 'Prélèvements suspendus',
    title: 'Prélèvements SEPA',
  },
});

export default locales;
